import { Component, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { averageAmountTransactionsOptions } from '@app/forms/subscription/services/ref';

@Component({
    selector: 'scpi-average-amount-transactions',
    templateUrl: './scpi-average-amount-transactions.component.html',
    styleUrls: ['./scpi-average-amount-transactions.component.scss'],
    standalone: false
})
export class ScpiAverageAmountTransactionsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = averageAmountTransactionsOptions;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
